import Theme from '../Theme';
import ThemeFive from '../ThemeFive';
import ThemeEight from '../ThemeEight';
import ThemeNine from '../ThemeNine';
import ThemeOne from '../ThemeOne';
import ThemeSeven from '../ThemeSeven';
import ThemeSix from '../ThemeSix';
import ThemeThree from '../ThemeThree';

export default function ThemeSwitch({ attributes, setAttributes }) {

    const { theme = "default" } = attributes;

    return <ThemeChange theme={theme} {...{ attributes, setAttributes }} />
}

const ThemeChange = ({ theme, attributes, setAttributes }) => {
    switch (theme) {
        case 'themeOne':
            return <ThemeOne {...{ attributes, setAttributes }} />
        case 'themeTwo':
            return <ThemeSix {...{ attributes, setAttributes }} />
        case 'themeThree':
            return <ThemeNine {...{ attributes, setAttributes }} />;
        case 'themeFour':
            return <ThemeEight {...{ attributes, setAttributes }}/>
        case 'themeFive':
            return <ThemeFive {...{ attributes, setAttributes }} />;
        case 'themeSeven':
            return <ThemeThree {...{ attributes, setAttributes, }} />;
        case 'themeEight':
            return <Theme {...{ attributes, setAttributes, }} />;
        default:
            return <ThemeSeven {...{ attributes, setAttributes }} />;

    }
}
